import { type ReactNode } from 'react';
import { Wallet } from 'lucide-react';
import { Spinner } from '@/components/ui/spinner';
import { useCollectorSummary } from '../hooks/use-collector-earnings';
import { formatUSD } from '../utils/payment-formatters';
import type { CollectorSummary } from '../types';
import { MilestoneBar } from './milestone-bar';

function Header(): ReactNode {
  return (
    <div className="flex items-center gap-sm">
      <Wallet size={14} className="text-brand-red" />
      <p className="text-[10px] font-medium uppercase tracking-wider text-text-tertiary/60">
        Progreso de pago semanal
      </p>
    </div>
  );
}

export function PaymentProgressCard({
  summary,
}: {
  summary: CollectorSummary;
}): ReactNode {
  return (
    <div className="rounded-xl bg-white/[0.02] p-base">
      <Header />
      <p className="mt-sm text-lg font-bold text-text-primary">
        {formatUSD(summary.accumulated)}
      </p>
      <MilestoneBar
        accumulated={summary.accumulated}
        threshold={summary.payment_threshold}
      />
      {summary.next_payment_message ? (
        <p className="mt-sm text-xs text-text-secondary">
          {summary.next_payment_message}
        </p>
      ) : null}
    </div>
  );
}

export function EarningsProgressCard({
  userId,
}: {
  userId: string;
}): ReactNode {
  const { data, isLoading } = useCollectorSummary(userId);
  if (isLoading) return <Spinner />;
  if (!data) return null;
  return <PaymentProgressCard summary={data} />;
}
